import { Heading, Tag, Text } from "@ttc3k/trekker";
import { Box, Flex } from "styled-system/jsx";

type PromotionSectionHeaderProps = {
  step: number;
  title: string;
  description?: string;
};

/** Numbered section title with a trailing rule, per the promo-form design. */
export const PromotionSectionHeader = ({
  step,
  title,
  description,
}: PromotionSectionHeaderProps) => (
  <Flex flexDir="column" gap="100">
    <Flex flexDir="row" alignItems="center" gap="150" h="40px">
      <Tag visual="primary" w="24px" h="24px" flexShrink={0}>
        {step}
      </Tag>
      <Heading size="h5" whiteSpace="nowrap">
        {title}
      </Heading>
      <Box flex="1" h="1px" bg="border.light" />
    </Flex>
    {description && (
      <Text visual="bodyRegular" color="text.mid">
        {description}
      </Text>
    )}
  </Flex>
);
